/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Tag, Box } from 'chakra-v3';
import { RiCloseLine } from 'react-icons/ri';

export interface ListItemProps {
  label: string;
  handleRemove: (label: string) => void;
  isDisabled?: boolean;
}
export function ListItem(props: ListItemProps) {
  const { label, handleRemove, isDisabled } = props;
  return (
    <Tag.Root
      bg="tag.background"
      color="tag.text"
      borderRadius="4px"
      px="8px"
      py="4px"
      fontSize="16px"
      lineHeight="1.4"
      letterSpacing="0.08px"
      fontFamily="body"
      fontWeight="normal"
      display="inline-flex"
      alignItems="center"
      gap="8px"
    >
      <Tag.Label color="tag.text">{label}</Tag.Label>
      {!isDisabled && (
        <Tag.EndElement>
          <Box
            as="button"
            onClick={() => handleRemove(label)}
            cursor="pointer"
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="tag.text"
            _hover={{ opacity: 0.7 }}
            aria-label={`Remove ${label}`}
          >
            <RiCloseLine size={16} />
          </Box>
        </Tag.EndElement>
      )}
    </Tag.Root>
  );
}
